// -*-mode: rjsx -*-
// REACT
import React  from "react"
// eslint-disable-next-line
import clsx from "clsx"

// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"
import Button from "@material-ui/core/Button"

// COLORS
// eslint-disable-next-line
import lime from "@material-ui/core/colors/lime"
// eslint-disable-next-line
import grey from "@material-ui/core/colors/grey"
// eslint-disable-next-line
import red from "@material-ui/core/colors/red"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashSentimentPad>")

const useDefaultStyles = makeStyles(theme => ({
    rootDiv: {
//        position: "fixed",
//        bottom: 0,
//        width: "100%",
        zIndex: 1000,
        height: 72,

        //
        // mobile
        //
        marginTop: 10,
        marginBottom: 70 ,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 30,
            marginBottom: 30,
        },

        
        // below is the actual texcture - it does work
        //        backgroundColor: grey[200], 
        //        borderTop: "1px solid",
        //        borderTopColor: grey[300],
        //	borderRadius: 0,
    },

    buttonsDiv: {
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        width: "100%",
        height: 72,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
	    maxWidth: 600,
        },

    },


    rightButtonDiv: {
        width: "30%",
        height: "55%",
    },

    rightButtonLongDiv: {
        width: "55%",
        height: "55%",
    },

    leftButtonDiv: {
        width: "30%",
        height: "55%",
    },


    rightButton: {
        width: "100%",
        height: "100%",
        
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.rightButton,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.rightButtonLight,
        },
        
    },

    leftButton: {
        width: "100%",
        height: "100%",
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.custom.leftButton,
        "&:hover": {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.custom.leftButtonLight,
        },
    },
    
}), { name: "FlashSentimentPad" })

// keep adding this stuff

let FlashSentimentPad = (props) => {

    // eslint-disable-next-line
    const { children, leftButton, rightButton } = props

    const classes = {
        ...useDefaultStyles(),
    }

   
    /*
    const [redirectState, setRedirect] = useState({
        toRedirect: false,
        toLink: null
    })
    */
    
    const handleLeftClick = () => {
        log.debug("handleLeftClick()")
        leftButton.onClick("negative")
    }

    const handleRightClick = () => {
        log.debug("handleRightClick()")
        rightButton.onClick("positive")
    }

    /*
    useEffect(() => {
    })
    */

    /*
    if(redirectState.toRedirect) {
        redirectState.toRedirect = false
        return (<Redirect push to={redirectState.toLink}/>)
    }
    */

    return (
        <div className={classes.rootDiv}>
          <div style={{display: "flex", alignItems:"center", justifyContent: "center"}}>
            <div className={classes.buttonsDiv}>
              { leftButton &&
                <div className={classes.leftButtonDiv}>
                  <Button className={classes.leftButton} onClick={handleLeftClick}>{leftButton.text}</Button>
                </div>
              }

              { rightButton &&
                <div className={clsx(classes.rightButtonDiv, {
                    [classes.rightButtonLongDiv]: rightButton.text.length > 10
                })}>
                  <Button className={classes.rightButton} onClick={handleRightClick}>{rightButton.text}</Button>
                </div>
              }
            </div>
          </div>
          
        </div>
    )
}

export default FlashSentimentPad

